/* global jQuery COMPONENTS */

COMPONENTS.ComponentPageIntro = (function ($) {
  function ComponentPageIntro () {
    this.$sliderElem = $('[data-ecs-components-control="intro-slider"]')
    this.$component = $('[data-ecs-component="component-pageintro"]')

    // Video variables
    this.$plyrElem = this.$component.find('[data-ecs-components-control="pageintro-plyr"]')
    this.$plyrParent = this.$component.find('.ecs_pageintro_video')
    this.videoSettings = {}
    this.videoSettings.load = {}
    if (this.$plyrParent.length > 0) {
      if (typeof this.$plyrParent.attr('data-ecs-plyr-controls') != 'undefined') {
        this.videoSettings.controls = this.$plyrParent.attr('data-ecs-plyr-controls').split(', ')
      }
      this.videoSettings.load.play = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-play')
      this.videoSettings.load.mute = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-mute')
      this.videoSettings.load.cc = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-cc')
      this.videoSettings.load.mobile = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-on-mobile')
    }
    
    if (this.$plyrElem) {
      this.videoSettings.aspectRatio = ''
      if (typeof this.$plyrElem.attr('data-ecs-aspect-ratio') !== 'undefined' && this.$plyrElem.attr('data-ecs-aspect-ratio') !== false) {
        this.videoSettings.aspectRatio = this.$plyrElem.attr('data-ecs-aspect-ratio')
      }
    }

    const utility = new COMPONENTS.Utility()

    // Page intro always shows a single slide
    this.sliderVars = utility.getSliderVars(1)

    this.videoInitialized = false
  }

  ComponentPageIntro.prototype.initSlider = function () {
    this.$sliderElem.slick(this.sliderVars)
  }

  ComponentPageIntro.prototype.initVideo = function () {
    const component = this
    var plyrSettings = {
      autopause: false,
      autoplay: component.videoSettings.load.play,
      captions: {
        active: component.videoSettings.load.cc,
        language: 'auto',
        update: false
      },
      clickToPlay: true,
      controls: component.videoSettings.controls,
      fullscreen: {
        enabled: false,
        fallback: true,
        iosNative: false
      },
      hideControls: false,
      keyboard: {
        focused: true,
        global: false
      },
      loadSprite: true,
      loop: {
        active: true
      },
      muted: component.videoSettings.load.mute,
      volume: 0,
      ratio: component.videoSettings.aspectRatio,
      tooltips: {
        controls: false,
        seek: true
      },
      vimeo: {
        autoplay: component.videoSettings.load.play,
        controls: true,
        loop: true,
        muted: component.videoSettings.load.mute,
        portrait: false,
        texttrack: '',
        title: false,
        cc: component.videoSettings.load.cc
      },
      youtube: {
        autoplay: 1,
        controls: 1,
        disablekb: 0, // keyboard controls
        fs: 0, // fullscreen
        loop: 1,
        modestbranding: 1,
        cc_load_policy: + component.videoSettings.load.cc
      }
    }

    if (plyr_required) {
      if (component.$plyrElem.length >= 1) {
        component.plyr = new Plyr(component.$plyrElem, plyrSettings)
        if (component.videoSettings.load.play != false) {
          component.plyr.on('ready', () => {
            component.plyr.muted = true
            component.plyr.play()
          })
        }

        component.plyr.on('playing', () => {
          component.$component.find('.ecs_pageintro_video').addClass('ecs_plyr_loaded')
        })
      }
    }
  }

  ComponentPageIntro.prototype.init = function () {
    const component = this
    const windowMobile = window.matchMedia('(min-width: 768px)')

    component.initSlider()

    // Check viewport width OR if video on mobile load is enabled before loading Video
    if (windowMobile.matches || this.videoSettings.load.mobile) {
      if (typeof ecs_cookie_consent_active !== 'undefined' && ecs_cookie_consent_active) {
        // Plyr with Vimeo makes connections that set Vimeo cookies on init.
        // Defer until the user grants analytics consent.
        document.addEventListener('ecsCookieAccept', function () {
          if (!component.videoInitialized) {
            component.videoInitialized = true
            component.initVideo()
          }
        })
        document.addEventListener('ecsCookieCheck', function (e) {
          var cats = e.detail && e.detail.cookie && e.detail.cookie.categories
          if (cats && cats.length >= 2 && !cats.every(function (c) { return c === 'necessary' })) {
            if (!component.videoInitialized) {
              component.videoInitialized = true
              component.initVideo()
            }
          }
        })
      } else {
        component.initVideo()
      }
    }
  }

  return ComponentPageIntro
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentpageIntro = new COMPONENTS.ComponentPageIntro()
  COMPONENTS.ComponentpageIntro.init()
})
